/*=========================================================================================
  File Name: moduleDashboardRequest.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleDashboardRequestState.js";
import mutations from "./moduleDashboardRequestMutations.js";
import actions from "./moduleDashboardRequestActions.js";
import getters from "./moduleDashboardRequestGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
